<div class="subheader with-padding flgrow" style="position: relative">
  <div class="row align-items-center">
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-8 maxw600">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="input-group">
            <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblQuicksearch' | translate }}"
              [(ngModel)]="searchTerm" autocomplete="off" (keyup.enter)="onQuickSerch()"/>
            <div class="input-group-append">
              <button type="button" class="btn btn-primary" (click)="onQuickSerch()">
                <i class="fa fa-search" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="ml-2 advanced-search-box">
          <button type="button" class="btn btn-primary" (click)="onSearch()" aria-label="Center Align">
            <em class="fa fa-search-plus" aria-hidden="true"></em>
          </button>
          <div class="searchbox card fix lt width800px" *ngIf="isAdvanceSearch">
            <div class="row mt-3">
              <div class="col-4">
                <label translate>lblWoNo</label>
                <input class="form-control" type="text" name="woNumber" [(ngModel)]="LockedAppointmentData.WorkOrderNo"
                  maxlength="15" autocomplete="off" />
              </div>
              <div class="col-4">
                <label translate> lblLockedDate </label>
                <div class="date">
                    <input bsDaterangepicker name="lockedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
                    [(ngModel)]="lockedOnDate" required />
                </div>
              </div>
              <div class="col-4">
                <label translate> lblUnLockedDate</label>
                <div class="date">
                    <input bsDaterangepicker name="unlockedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
                    [(ngModel)]="unlockedOnDate" required />
                </div>
              </div>
            </div>
            <div class="mb-3"></div>
            <hr />
            <div class="row">
              <div class="col text-left">
              </div>
              <div class="col-auto me-auto text-right">
                <button type="submit" (click)="AdvanceSearchSubmit()" aria-label="Center Align"
                  class="btn btn-primary mr-sm-2" translate>lblApply
                </button>
                <button (click)="onReset()" aria-label="Center Align" class="btn btn-outline-tertiary mr-sm-2"
                  translate>lblReset
                </button>
                <button (click)="onClose()" aria-label="Center Align" class="btn btn-outline-tertiary"
                  translate>lblClose
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-xl-9 col-lg-5 col-md-12 relative flmid mt-3 mt-lg-0 justify-content-md-end justify-content-lg-start">
      <button type="submit" (click)="onClickChangeView(false)" [ngClass]="
          isTodayViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'
        " class="mr-sm-2" translate>
        lblSATodayView
      </button>
      <button (click)="onClickChangeView(true)" [ngClass]="isWeekViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'"
        class="" translate>
        lblSAWeekView
      </button>
      <div
        class="col-xl-9 col-md-7 col-lg-6 d-flex align-items-center flex-sm-row flex-column justify-content-end ">
        <button type="button" (click)="exportAsXLSX(documentTypes.Excel)" ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom"
          aria-label="Center Align">
          <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
        </button>
        <button class="ml-2 btn btn-link icon-pdf" type="button" (click)="onDownloadPDF(documentTypes.Pdf)"
          ngbTooltip="{{'lblExportPDF' | translate}}" placement="bottom" aria-label="Center Align">
          <em class="far fa-file fa-2x"></em>
          <span class="bdg">PDF</span>
        </button>
        <a class="ml-3 btn btn-outline-primary" href="javascript:void(0);" (click)="refresh()"
          aria-label="Center Align">
          <em class="fas fa-sync fa-lg"></em>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex" translate>lblAppointmentLock</div>
        <div class="table-responsive max-h357" infinite-scroll [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
          <table class="tablest1" id="lockappointment">
            <thead>
              <tr>
                <th scope="col" style="width: 10%">#</th>
                <th scope="col" sortable="WorkOrderNo" (sort)="onSort($event)" translate>lblWoNo</th>
                <th scope="col" sortable="LockedByName" (sort)="onSort($event)" translate>
                  lblLockedBy
                </th>
                <th scope="col" sortable="LockedOn" (sort)="onSort($event)" translate>
                  lblLockedDate
                </th>
                <th scope="col" sortable="UnlockedByName" (sort)="onSort($event)" translate>
                  lblUnLockedBy
                </th>
                <th scope="col" sortable="UnlockedOn" (sort)="onSort($event)" translate>
                  lblUnLockedDate
                </th>
                <th translate class="text-center">
                  lblAction
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="LockedAppointmentResponse?.length > 0; else load_else">
                <tr *ngFor="let item of LockedAppointmentResponse; let i = index ">
                  <td>
                    {{i+1}}
                  </td>
                  <td>
                    <ngb-highlight [result]="item.workorderNo"> </ngb-highlight>
                  </td>
                  <td>
                    {{item.lockedByName}}
                  </td>
                  <td>
                    {{item.lockedOn ? (getLocalDate(item.lockedOn) | date:'short') : ''}}
                  </td>
                  <td>
                    {{item.unlockedByName}}
                  </td>
                  <td>
                    {{item.unlockedOn ? (getLocalDate(item.unlockedOn) | date:'short') : ''}}
                  </td>
                  <td class="nowrap text-center">
                    <a class="btn btn-ico" ngbTooltip="{{'lblUnlockAppointment' | translate}}" tooltipClass="custom-revert" *ngIf="item.isLocked && userRoleRightsDetails.canEdit"
                      (click)="UnlockAppointment(item)">
                      <em class="fas fa-unlock"></em>
                    </a>
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="8" class="no-record" translate>
                    lblNoRecordsFound
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <app-pagination [pager]="pager" [recordSize]="totalCount" (setPageEvent)="setPage($event)"></app-pagination>
            <div class="d-flex align-items-center justify-content-between font17 fontbold">
              <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{totalCount}}&nbsp;<span
                class="font17 fontnormal" translate>lblResults</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>